"use client";

import { useId } from "react";

type StatIcon = "wage" | "growth" | "openings";

/** Puck can mount hidden and visible inspectors with the same field identity. */
export function StatIconField({
  id,
  value,
  onChange,
  readOnly,
}: {
  id: string;
  value: StatIcon | undefined;
  onChange: (value: StatIcon | undefined) => void;
  readOnly?: boolean;
}) {
  const instanceId = useId();
  const domId = `${id}-${instanceId}`;
  return (
    <div style={{ display: "grid", gap: 8 }}>
      <label htmlFor={domId}>Icon</label>
      <select
        id={domId}
        value={value ?? ""}
        disabled={readOnly}
        onChange={(event) => {
          const selected = event.target.value;
          onChange(
            selected === "wage" || selected === "growth" || selected === "openings"
              ? selected
              : undefined
          );
        }}
        style={{ padding: 8 }}
      >
        <option value="">None</option>
        <option value="wage">Wage ($)</option>
        <option value="growth">Growth (↗)</option>
        <option value="openings">Openings (+)</option>
      </select>
    </div>
  );
}
